export default __webpack_public_path__ + "static/media/avatar-placeholder.dfb5700f.png";